if (typeof UseSwStat == 'undefined' || typeof UseSwStat == 'null') {
    var UseSwStat = false;
}

if (typeof UseTagManager == 'undefined' || typeof UseTagManager == 'null') {
    UseTagManager = false;
}

function setContentHeight() {
    if ($(window).width() < 768) {
        var ContentHeight = $(".SepetProducts").height() - 270;
        $(".BasketCenterContent").height(ContentHeight);
        $(".BasketCenterContent").css("max-height", ContentHeight);
    } else {
        var ContentHeight2 = $(".SepetProducts").height() - 285;
        $(".BasketCenterContent").height(ContentHeight2);
        $(".BasketCenterContent").css("max-height", ContentHeight2);
    }

    $(window).resize(function () {
        if ($(window).width() < 768) {
            var ContentHeight3 = $(".SepetProducts").height() - 270;
            $(".BasketCenterContent").height(ContentHeight3);
            $(".BasketCenterContent").css("max-height", ContentHeight3);
        } else {
            var ContentHeight4 = $(".SepetProducts").height() - 285;
            $(".BasketCenterContent").height(ContentHeight4);
            $(".BasketCenterContent").css("max-height", ContentHeight4);
        }
    });
}

function toggleBasket() {

    if ($(".SepetProducts").is(":visible")) {
        $(".SepetProducts").stop().animate({ "left": "100%" }, 200, function () {
            $(".SepetProducts").stop().hide();
            $("body").removeClass("BasketDropped");
            $("body").removeClass("BackDropped");
        });
    }
    else {
        //$(".SepetProducts").stop().animate({ "left": "83%" }, 200, function () {
        $(".SepetProducts").stop().animate({ "right": "0%" }, 200, function () {
            $(".SepetProducts").stop().show();
            setContentHeight();
            $("body").addClass("BasketDropped");
        });
    }
}

function TagAutoComplate() {

    if ($("#SmallLangCode").val() != 'en') {

        $(".customAutoComplete").autocomplete({

            source: "/" + $("#SmallLangCode").val() + "/p/Cat/CompleteNames",
            minLength: 2,
            maxResults: 10,
            select: function (event, ui) {


                if (ui.item.FilterType == "Product") {
                    window.location.href = "/" + $("#SmallLangCode").val() + "/" + ui.item.HexValue;
                }

                if (ui.item.FilterType == "Tag" || ui.item.FilterType == "Color") {
                    window.location.href = "/" + $("#SmallLangCode").val() + "/p/Cat/NewSearch?sr=" + ui.item.MainValue;
                }


                //if (ui.item.FilterType == "BlogPost") {
                //    window.location.href = "/blog" + ui.item.SubValue;
                //}

                //$(".SearchModal input:first").val(ui.item.value);
                //$(".SearchModal form").submit();
            }
            ,
            create: function () {



                $(this).data('ui-autocomplete')._renderItem = function (ul, item) {


                    if (item.FilterType == "Product") {
                        $li = $('<li class="PrItem">').append('<img src="' + item.ImagePath + '" alt="" />');

                        $li.append("<span class='PrHeader'>" + item.SubValue + "</span>");
                        $li.append("<span>" + item.MainValue + "</span>");
                        $li.append("<span class='Info'></span>");

                        $li.appendTo(ul);

                        return $li;

                    }
                    if (item.FilterType == "BlogPost") {

                        $li = $('<li class="BlogItem">').append('<img src="' + item.ImagePath + '" alt="" />');

                        $li.append("<span class='BlogHeader'>" + item.MainValue + "</span>");
                        $li.append("<span>" + item.HexValue + "</span>");
                        $li.append("<span class='Info'></span>");

                        $li.appendTo(ul);

                        return $li;

                    }
                    else
                        if (item.FilterType == "Color") {

                            var colorCode = item.HexValue;
                            //if (!item.HexValue.includes("#")) {
                            //    colorCode = "#" + colorCode;
                            //}

                            $li = $('<li class="ColorItem">').append('<span class="HexItem" style="background-color:' + colorCode + '" alt="" />');

                            $li.append("<div class='ColorHeader'>" + item.MainValue + "</span><span>Renklerde Arayın</span>");
                            $li.append("");
                            $li.append("<span class='Info'></span>");

                            $li.appendTo(ul);

                            return $li;

                        }
                        //else if (item.FilterType == "Tag") {

                        //    return $('<li class="TagItem">')
                        //            .append('<a href="' + "/" + $("#SmallLangCode").val() + "/Tags/" + item.SubValue + '">' + item.MainValue + '</a>')
                        //            .append("<span class='Info'></span>")
                        //            .appendTo(ul);
                        //}
                        else {
                            return $('<li>')
                                .append(item.MainValue)
                                .appendTo(ul);
                        }

                };
            },
            focus: function (event, ui) {

                event.preventDefault();

                $(".SearchModal form input:first").val(ui.item.MainValue);

            }

        });
    }
}

function GetHelp(x) {

    $('.help_div').hide();
    $('.help_' + x).show();


    $('.help_' + x).children("div.subhelp:first").show();


}

function changeSiteLanguage(langID, langCode) {

    var url = "/";
    var Catalogs = $("#PgCatalogs").val().split("/");
    var ctlgs = "";

    for (var i = 0; i < Catalogs.length; i++) {
        if (Catalogs[i].length > 0) {
            ctlgs += "&Cats=" + Catalogs[i];
        }
    }

    $.ajax({
        type: 'get',
        url: '/Home/ChangePageLang',
        data: 'PID=' + $("#PID").val() + "&PgType=" + $("#PgType").val() + "&AName=" + $("#AName").val() + "&CName=" + $("#CName").val() + "&langID=" + langID + ctlgs + "&langCode=" + langCode,
        success: function (dt) {
            window.parent.location.href = dt;
        }
    });

}

function changeSiteTheme(layout) {

    //var hs = window.location.hash;
    //hs = hs.replace("=", "[_]");
    //hs = hs.replace("&", "[and]")

    $.ajax({
        type: 'get',
        url: '/Home/ChangeTheme',
        data: 'Url=' + window.location.pathname + "&th=" + layout + "&hash=" + window.location.hash,
        success: function (dt) {

            window.parent.location.href = dt;
        }
    });

}

function ShowLangAreaForChange() {


    var userLang = navigator.language || navigator.userLanguage;

    if (userLang != null && userLang != undefined && userLang.length > 2) {

        userLang = userLang.substr(0, 2).toLowerCase();
    }

    $.ajax({
        type: "GET",
        url: "/" + $("#SmallLangCode").val() + "/p/Home/ShowLangSwitch",
        success: function (data) {

            if ($(".LangSelectionArea").length <= 0) {

                if (document.URL.indexOf("localhost") >= 0) {

                    $(".FixedHeader > .container:first").prepend(data);
                }

            } else if ($(".LangSelectionArea").hasClass("gizle")) {

                if (document.URL.indexOf("localhost") >= 0) {

                    $(".LangSelectionArea").show();
                }

            } else {

                $(".LangSelectionArea").hide();
            }

        }
    });

}

function ShowCurrencyForChange() {


    $.ajax({
        type: "GET",
        url: "/" + $("#SmallLangCode").val() + "/p/Home/ShowCurrencySwitch",
        success: function (data) {

            if ($(".CurrrencySelectionArea").length <= 0) {

                if ($(".AllowCurrencyChange").length > 0) {

                    $(".FixedHeader > .container:first").prepend(data);
                }

            } else if ($(".CurrrencySelectionArea").hasClass("gizle")) {

                if ($(".AllowCurrencyChange").length > 0) {

                    $(".CurrencySelectionArea").show();
                }


            } else {

                $(".CurrrencySelectionArea").hide();
            }

        }
    });

}

function AddToFavoriteNewMain(ProductID, ColorID) {

    if (ColorID != undefined && ProductID != undefined) {

        $.ajax({
            type: 'get',
            url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddToFollowList",
            data: 'colorID=' + ColorID + "&productID=" + ProductID,
            dataType: 'json',
            async: true,
            success: function (dt) {
                if (dt.Sonuc == true) {

                    //#region Related Datalayer Add To Favorite Operation
                    if (dt.Deger8 !== null && dt.Deger8 !== undefined && window.dataLayer !== null && window.dataLayer !== undefined) {
                        window.dataLayer.push(JSON.parse(dt.Deger8));
                    }
                    //#endregion
                }
                else if (dt.Sonuc == false) {
                    alert('Favorilere eklemek için giriş yapınız!');

                }
            },
            error: function (httpObj, textStatus) {


                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');

            }
        });
    }

}

var mouse_is_inside_search = false;
var mouse_is_inside_userandBasket = false;
var mouse_is_inside_LeftMenu = false;
var mouse_is_inside_MainMenu = false;

function HideOpenWindows() {

    if (!mouse_is_inside_search) {

        $(".SearchModal").hide();

    }

    if (!mouse_is_inside_userandBasket) {

        $(".RightBasket").removeClass("active");
        $(".RightAccount ").removeClass("active");
        $("ul#MainMenu.Monitor > li").removeClass("open");

    }

    if (!mouse_is_inside_search && !mouse_is_inside_userandBasket && !mouse_is_inside_LeftMenu) {

        //$("body").removeClass("BackDropped");
    }

    if (!mouse_is_inside_MainMenu) {
        $("ul#MainMenu.Monitor > li").removeClass("open");
    }

}

$('.SearchModal form, .RightSearch').live({
    mouseenter:
        function () {
            mouse_is_inside_search = true;
        },
    mouseleave:
        function () {
            mouse_is_inside_search = false;
        }
});

$('.SubMenuContainer, #MainMenu').live({
    mouseenter:
        function () {
            mouse_is_inside_MainMenu = true;
            $(".FilterOption .slider").hide();
        },
    mouseleave:
        function () {
            mouse_is_inside_MainMenu = false;
            $(".FilterOption .slider").show();
        }
});

$.fn.exists = function () {
    return this.length !== 0;
}

var lastpos = -1;
var showTopLink = 100;
var width = 0;
var UserValue;

function LeftMenuFixedOptions() {
    $(window).scroll(function () {
        var TopValue = $("footer").height();


        if ($(window).scrollTop() + ($(window).height() + 300) > $(document).height()) {
            //$(".CategoryLeftBar").css("top", "-" + (TopValue) + "px");

        } else {

            $(".CategoryLeftBar").css("top", "inherit");
        }
    });
}

function setLink() {

    //if ($(window).width > 992) {
    //    $("#AccountLink").attr("href", "/" + $("#SmallLangCode").val() + "/User/UserInfo")
    //} else {
    //    $("#AccountLink").attr("href", "javascript:;")
    //}

    //$(window).resize(function () {
    //    if ($(window).width > 992) {
    //        $("#AccountLink").attr("href", "/" + $("#SmallLangCode").val() + "/User/UserInfo")
    //    } else {
    //        $("#AccountLink").attr("href", "javascript:;")
    //    }
    //});


}

function MobileMenuSetting() {
    $("#MainMenu > ul > li").each(function () {
        if (!$(this).hasClass("TabletMenu")) {
            $(this).addClass("row plus-icon mainItem");

            var dataBanner = $(this).attr("data-banner");
            $a = $(this).children("a");
            $(this).children("a").remove();
            var newa = "";
            if ($(this).find(".itemsWrapper").length > 0) {
                if (dataBanner != null && dataBanner != undefined) {
                    newa = "<a id='" + $a.attr("id") + "' data-rel='" + $a.attr("data-rel") + "' data-name='" + $a.attr("data-name") + "' data-url='" + $a.attr("data-url") + "' href='javascript:;'></a>";
                }
                else {
                    newa = "<a id='" + $a.attr("id") + "' data-rel='" + $a.attr("data-rel") + "' data-name='" + $a.attr("data-name") + "' href='javascript:;'>" + $a.html() + "</a>";
                }

            }
            else {
                if (dataBanner != null && dataBanner != undefined) {
                    newa = "<a id='" + $a.attr("id") + "' data-rel='" + $a.attr("data-rel") + "'data-name='" + $a.attr("data-name") + "' href='" + $a.attr("href") + "'></a>";
                }
                else {
                    newa = "<a id='" + $a.attr("id") + "' data-rel='" + $a.attr("data-rel") + "'data-name='" + $a.attr("data-name") + "' href='" + $a.attr("href") + "'>" + $a.html() + "</a>";
                }

            }
            $(this).prepend("<div class='col-xs-24 MainNavItem'>" + newa + "</div>");
        }
    });

    $(".ListWrapper > ul > li").each(function () {

        $a = $(this).children("a");
        var mainClass = "<div class='col-xs-20 SubNavItem'>";
        var newa = "<a data-rel='" + $a.attr("data-rel") + "' data-name='" + $a.attr("data-name") + "' href='" + $a.attr("href") + "'>" + $a.html() + "</a>";
        var newIcon = "";

        if ($(this).find("li").length > 0 && !$(this).hasClass("TabletMenu")) {
            $(this).addClass("plus-icon subItem");
            //newIcon = "<div class='col-xs-4 OpenChildrenMenu'><a href='javascript:;'><img src='/images/JMK/right_gift.png' /></a></div>";
            newIcon = "<div class='col-xs-4 OpenChildrenMenu'><a href='javascript:;'><div class='right-gift'></div></a></div>";
        }
        else {
            mainClass = "<div class='col-xs-24 SubNavItem'>";
        }

        $(this).addClass("row");
        $(this).children("a").remove();
        $(this).prepend(mainClass + newa + "</div>" + newIcon);

    });



}

//function AddToFavorite() {
//    $(".passiveFavorite").live("click", function () {
//        var ColorID = $("#ColorID").val();
//        var ProductID = $("#ProductID").val();
//        $That = $(this);
//        if (ColorID != undefined && ProductID != undefined) {
//            $.ajax({
//                type: 'get',
//                url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddToFollowList",
//                data: 'colorID=' + ColorID + "&productID=" + ProductID,
//                dataType: 'json',
//                async: true,
//                success: function (dt) {
//                    if (dt.Sonuc == true) {
//                        $That.addClass("activeFavorite");
//                        $That.removeClass("passiveFavorite");
//                    }
//                }
//            });
//        }
//    });
//}

//function removeFavorite() {
//    $(".activeFavorite").live("click", function () {
//        var ProductID = $("#ProductID").val();
//        $That = $(this);
//        if (ProductID != undefined) {
//            $.ajax({
//                type: 'get',
//                url: "/" + $("#SmallLangCode").val() + "/p/Cart/RemoveFromList",
//                data: 'id=' + ProductID + "&IsDetail=true",
//                dataType: 'json',
//                async: true,
//                success: function (dt) {
//                    if (dt.Sonuc == true) {
//                        $That.addClass("passiveFavorite");
//                        $That.removeClass("activeFavorite");
//                    }
//                }
//            });
//        }
//    });
//}

function ToggleFooterMenu() {
    $(".footerLinks .footerMenu").live("click", function () {
        $(this).find("ul").slideToggle();
    });
}

function Isfollow() {
    var productId = $("#ProductID").val();
    var curColorId = $("#CurrentColorId").val();
    $That = $(".AddToFavorite");

    if (productId != undefined) {
        $.ajax({
            type: 'get',
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/IsFollow",
            data: 'productId=' + productId + '&currentColorId=' + curColorId,
            dataType: 'json',
            async: true,
            success: function (dt) {
                if (dt.IsFollow == true) {
                    $That.removeClass("passiveFavorite");
                    $That.addClass("activeFavorite");
                } else {
                    $That.addClass("passiveFavorite");
                    $That.removeClass("activeFavorite");
                }
            }
        });
    }
}

function AddToCartAreaWidthSet() {

    var $curWidth = $('.PrdImgsBox:first').width();

    //$(".ProductList > div > div.PrdImgsBox .AddToCartArea").css('width', $curWidth);
}

function ToggleSystem() {
    if ($(window).width() <= 991) {
        $(document).on("click", ".ToggleAccountMenu", function (e) {
            $(".AccountMenu").toggle();
        });
    }
}

function AddSearchBox() {
    var searchSelector = SearchBox('.HeaderSearchArea .SearchIcon');
    searchSelector.init();
    window.searchBox = searchSelector;
}

$(".SearchIcon").live("click", function () {
    $("#UserMenus .TopBarLinks .sb .SearchBoxBorder").addClass("hidden-md");
    TagAutoComplate();
    $(".SearchBox #search").focus();
});

function HeaderLinkClickEvents() {
    $(".RightAccount a").live("click", function () {
        CloseLeftMenu();
    });

    $(".RightBasket a").live("click", function () {
        CloseLeftMenu();
    });
}

function CloseLeftMenu() {
    $("#MainMenu").removeClass("open");
    $("body").removeClass("LeftMenuOpen");
    $("html").removeClass("noScroll");
}

function CloseShowWrapper() {
    $(".Mainmenu .ShowWrapper").each(function () {
        $(this).removeClass("ShowWrapper");
    });

    $("#MainMenu").removeClass("openSub");
}

function CloseSubShowWrapper() {
    $(".ShowWrapper .ShowSubWrapper").each(function () {
        $(this).removeClass("ShowSubWrapper");
    });
}

function HiddenMdLgSearchButton() {

    var url = $(location).attr('href');
    var urlTr = "/tr/";
    var Result = url.indexOf(urlTr);

    if (Result == -1) {
        $('#MobileSearch').show();
    }
    else {
        $('#MobileSearch').hide();
        $('.MobileSearchButtonJK').click(function () {
            $('#MobileSearch').slideToggle('fast');
        });
    }
}

$(document).ready(function () {

    HiddenMdLgSearchButton();
    ToggleSystem();
    //AddSearchBox();

    $('.FooterTextShowMore').on('click', function (e, index) {

        $(this).hide();
        $('.FooterTextShowLess').show();
        $('.FooterTextSecondPart').show();
    });

    if ($(window).width() < 767) {
        $("#MainMenu > ul > li > .itemsWrapper").closest("a").attr("href", "javascript:;");
    }

    //if (document.URL.indexOf("/outlet") != -1 && $("#MainMenu .outlet").length > 0) {
    //    $("#MainMenu .outlet").show();
    //    $("#MainMenu .outlet").prev().hide();
    //}

    $("#MainMenu > ul > li > .itemsWrapper > .ListWrapper").each(function () {
        var that = $(this);
        if (that.find(" ul > li > .itemsWrapper").length <= 0) {
            //Sub Head doesnt Contains
            that.parent().addClass("SubHeadDCItems");
        }
    });

    $("#MainMenu > ul > li").on("mouseover", function () {
        $($(this).children(".itemsWrapper").children(".ListWrapper").children("ul").children("li")).each(function (i) {
            if ($(this).find("div").length > 0) {
                $(this).parent().css('font-weight', 'bold');
            }
            else {
                $(this).children().css('font-weight', 'normal');
                $(this).children().css('text-transform', 'none');
            }
        });
    });

    $('.FooterTextShowLess').on('click', function (e, index) {

        $(this).hide();
        $('.FooterTextShowMore').show();
        $('.FooterTextSecondPart').hide();

    });

    $(".SepetProducts .closeImage").live("click", function () {
        toggleBasket();
        $(".SepetProducts").removeClass("activeBasket");
        $("body").removeClass("BasketDropped");
        $("body").removeClass("BackDropped");
    });

    $("#MainMenu > ul > li").on("click", function () {
        if ($(window).width() < 992 && !$(this).hasClass("TabletMenu") && !$(this).find(".itemsWrapper").length <= 0) {
            //$(this).find(".itemsWrapper").slideToggle();
            //$(this).toggleClass("minus-icon");
        }
    });

    if (isMobile(true)) {
        MobileMenuSetting();
    }

    LeftMenuFixedOptions();

    //AddToFavorite();
    //removeFavorite();
    Isfollow();

    if ($(window).width() < 992) {
        ToggleFooterMenu();
    }

    $("a#ContinueShop").live("click", function () {
        location.reload();
    });

    //NewsletterPopupControl();

    if ($(window).width < 980) {
        $("#LoginRegisterModal .modal-content").css("background-image", "none");
        $("#LoginRegisterModal .modal-content").removeAttr("style");
    }

    $('.top_link').hide();
    width = $(window).width();

    $('.OpenLeftMenu').hover(function () {
        mouse_is_inside_LeftMenu = true;
    }, function () {
        mouse_is_inside_LeftMenu = false;
    });

    $('.UserAndBasket, .BasketContainer').live({
        mouseenter:
            function () {

                mouse_is_inside_userandBasket = true;

            },
        mouseleave:
            function () {
                mouse_is_inside_userandBasket = false;
            }
    });

    var ThemePath = "/Images/BlackTheme/";

    if ($(".LogoContainer img").length > 0) {
        ThemePath = $(".LogoContainer img:first").attr("src").replace("Logo.png", "");
    }

    //Menu 
    if ($("ul#MainMenu").length > 0) {
        //$("ul#MainMenu").ResponsiveMenu();
    }

    // alert("ismobile:" + isMobile(true) + " IsChrome:" + IsChrome() + " IsFirefox:" + IsFirefox() + "IsSafari:" + IsSafari() + " agent:" + navigator.userAgent.toLowerCase() );

    //if (isMobile(true) && (IsChrome() || IsFirefox() || IsSafari())) {
    //    $("#MainMenu").css("display", "block");
    //}

    $('.carousel').carousel();

    $(".carousel").swiperight(function (e) {//lazım olursa ekleriz   .die("swiperight").live("swiperight", function () {
        $(this).carousel('prev');
        e.preventDefault();
        return false;
    });
    $(".carousel").swipeleft(function (e) {//.die("swipeleft").live("swipeleft", function () {
        $(this).carousel('next');
        e.preventDefault();
        return false;
    });

    //$("#MainMenu.Monitor > li:has('.BWOSubMenuShow'), .RightBasket, .RightAccount").live({
    $("#MainMenu.Monitor > li:has('.BWOSubMenuShow')").live({
        mouseenter:
            function () {
                if (!isMobile(true)) {
                    $("body").addClass("BackDropped");
                }
            },
        mouseleave:
            function () {
                if (!isMobile(true) && $(".SearchModal").css("display") != "block") {
                    $("body").removeClass("BackDropped");
                    $(".SepetProducts").removeClass("activeBasket");
                    $("ul#MainMenu.Monitor > li").removeClass("open");
                }
            }
    });

    //$("body.BackDropped:not(.OpenLeftMenu)").live("click", function () {
    //    HideOpenWindows();
    //});

    //$("body.BackDropped:not(.BasketContainer)").live("click", function () {

    //    if ($(".RightBasket.active").length > 0) {
    //        $(".RightBasket").removeClass("active");
    //    }

    //    if ($(".RightBasket.active").length > 0) {
    //        $(".RightBasket").removeClass("active");
    //    }

    //});

    //$("body .backdrop").on("click", function (e) {

    //    HideOpenWindows();

    //    $("body").removeClass("LeftMenuOpen BackDropped");
    //    $("#MainMenu").removeClass("open");
    //    //$(".SearchModal").hide();
    //    $(".RightBasket, .RightAccount").removeClass("active");
    //    $(".SepetProducts").removeClass("activeBasket");

    //});

    $("body .backdrop").on("click", function (e) {

        HideOpenWindows();

        $("body").removeClass("LeftMenuOpen BackDropped");
        $("#MainMenu").removeClass("open");

        $("body").removeClass("BasketDropped");
        hideBasket();
        //$(".SearchModal").hide();
        $(".RightBasket, .RightAccount").removeClass("active");
        $(".SepetProducts").removeClass("activeBasket");

    });

    $("body").on("click", function (e) {

        if (!mouse_is_inside_userandBasket) {
            $(".RightBasket.active").removeClass("active");
        }


    });

    $("body #PrdBlackBg").on("click", function (e) {

        $("#PrdBlackBg").hide();
        $(".SizeOptions.open").removeClass("PleaseSelect");
        $(".AddToBasket.PleaseSelect").removeClass("PleaseSelect");

        if ($(".AutoTextRep").length > 0) {
            $(".AutoTextRep button").text($(".AutoTextRep button").attr("data-first"));
        }
    });

    $('.top_link').click(function () {

        $('html, body').animate({ scrollTop: 0 }, 'slow');

    });

    $(window).scroll(function () {

        if ($(window).width() > 767) {
            if ($('.top_link').length > 0) {

                if ($(window).scrollTop() > showTopLink) {
                    $('.top_link').fadeIn('slow');
                } else {
                    $('.top_link').fadeOut('slow');
                }

            }
        }

        if ($(window).scrollTop() > showTopLink) {

            $("body").addClass("Scrolled");

        } else {
            $("body").removeClass("Scrolled");

        }


    });


    var rtime;
    var timeout = false;
    var delta = 500;

    $(window).resize(function () {

        rtime = new Date();
        if (timeout === false) {
            timeout = true;
            setTimeout(resizeend, delta);
        }
    });

    function resizeend() {
        if (new Date() - rtime < delta) {
            setTimeout(resizeend, delta);
        } else {
            timeout = false;
        }
    }

    $('.footerMenu .mainHead').click(function () {

        $(this).parent().toggleClass("open");

    });

    $("#CurrencySelectionDr").on("click", ".CurrencyItem", function () {

        var hs = window.location.hash;
        hs = hs.replace("=", "[_]");
        hs = hs.replace("&", "[and]")
        var CurrencyID = $(this).attr("data-id");

        $(".CurrenctCur img").attr("src", $(this).find("img").attr("src"));
        $(".CurrenctCur .TL").html($(this).find(".TL").html());
        $(".CurrenctCur .CurrCode").html($(this).find(".CurrCode").html());

        $.ajax({
            type: 'get',
            url: '/Home/ChangeCurrency',
            data: 'Url=' + window.location.pathname + "&currencyID=" + CurrencyID + "&hash=" + window.location.hash,
            success: function (dt) {

                window.location.reload(true);

            }
        });


    });

    $(".CloseModal").on("click", function () {
        $(this).parents(".modal").modal('hide');
    });

    $(".CloseModal").on("click", function () {
        $(this).parents(".modal").modal('hide');
    });


    $(".btn-back").live("click", function () {

        $(this).closest("form").slideUp();

    });

    $(".login-tabs").on("hidden.bs.tab", function (e) {
        var activeTab = $(this).children(".active");

        if (activeTab.hasClass("register-tab")) {
            $(".login-register-left").removeClass("hidden");
        }
        else {
            $(".login-register-left").addClass("hidden");
        }
    });

    $('body').on('hidden.bs.modal', '.modal', function () {
        $(this).removeData('bs.modal');
    });

    //$('.help_Uyelik, .help_Uyelik .subhelp').hide();
    $('.help_Uyelik, .help_Uyelik .subhelp:first').show();
    $('#helpMenu ul li:first a').addClass("secili");

    //if ($('.helpmenu li a').length > 0) {

    //Help Menu

    $('#helpMenu ul li a').on('click', function (e, index) {

        $('#helpMenu ul li a').removeClass('secili');
        $(this).addClass('secili');
        GetHelp($(this).attr('href').replace(/#/ig, ""));
    });

    $('.subhelptitle').on('click', function (e, index) {


        var c = $(this).attr('id').replace(/title/, "");
        $('.subhelp:visible').slideUp('fast');
        $('.' + c).slideDown('fast');

    });

    $("#HelpNavs div ul").first().show();
    $("#HelpContents ul li").hide();
    $("#HelpContents div").eq($("#HelpNavs div .HelpNavTitles").first().parent().index()).find("ul li:first").show();


    $('#HelpNavs li').click(function () {

        $("#HelpContents ul li").hide();

        $("#HelpContents div").eq($(this).closest("div").index()).find("ul li").eq($(this).index()).show();

    });

    $('#HelpNavs > div').click(function () {


        $("#HelpNavs div > ul").hide();
        $(this).find("ul").show("normal");


    });

    $('.HelpNavTitles').click(function () {

        $("#HelpContents ul li").hide();
        $("#HelpContents div").eq($(this).parent().index()).find("ul li:first").show();

    });


    function hideBasket() {
        $(".SepetProducts").stop().animate({ "left": "100%" }, 200, function () {
            $(".SepetProducts").stop().hide();
            $("body").removeClass("BasketDropped");
        });
    }

    function showBasket() {

        if ($(window).width() > 1199 && $(window).width() > 1510) {
            $(".SepetProducts").stop().animate({ "left": "75%" }, 200, function () {
                setContentHeight();
                $(".SepetProducts").stop().show();
                $("body").addClass("BasketDropped");
            });
        } else {
            $(".SepetProducts").stop().animate({ "left": "75%" }, 200, function () {
                setContentHeight();
                $(".SepetProducts").stop().show();
                $("body").addClass("BasketDropped");
            });
        }

    }

    $('.RightBasket').live('click', function (e) {

        e.preventDefault;
        //if (isMobile(true)) {

        var isCartActive = $(".RightBasket").hasClass("active");

        $("body").addClass("BasketDropped");

        $(".RightBasket").addClass("active");
        $(".RightAccount").removeClass("active");

        toggleBasket();

        if (!isCartActive) {
            e.preventDefault;
            return false;
        }

        //}

    });

    //--


    //$('.RightAccount').live('click', function (e) {
    //    if (isMobile(true)) {
    //        var isCartActive = $(".RightAccount").hasClass("active");
    //        //$("body").addClass("BackDropped");
    //        //$(".RightAccount").addClass("active");
    //        //$(".RightBasket").removeClass("active");
    //        if (!isCartActive) {
    //            e.preventDefault;
    //            return false;
    //        }
    //    }
    //});


    if ($("#UserAndBasket").length > 0) {

        $.ajax({
            type: 'get',
            url: "/" + $("#SmallLangCode").val() + "/p/Cart/GetSepetIcerik",
            data: "",
            async: true,
            cache: false,
            contentType: "application/json; charset=utf-8",
            dataType: 'text',
            success: function (dt) {
                $("#UserAndBasket").html(dt);

                AddSearchBox();
                TagAutoComplate();

                if ($("#LangRedirectNeed").length > 0) {
                    //  changeSiteLanguage("0", $("#LangRedirectNeed").val());
                }

                if ($("#LangSelectionNeed").length > 0) {
                    ShowLangAreaForChange();
                }

                var UserID = $("#UserID").val();

                if (UserID != undefined && UserID > 0) {
                    Isfollow();
                }

                if (UseTagManager) {
                    AddGeneralInfoTagManager('', dtIsLogged, dtUserID);

                    AddProductView('');
                    var promotions = GetPromotionsVariable('');
                    AddImpression('', promotions);
                    //  AddGASliderView('');

                    SendGaDataLayerVirtual();
                }
            }
        });
    }

    //function setBasketContainerHeight() {
    //    var ContentHeight = $(".SepetProducts").height() - 140;
    //    $(".BasketCenterContent").height(ContentHeight);
    //    $(".BasketCenterContent").css("max-height", ContentHeight);

    //    $(window).resize(function () {
    //        var ContentHeight = $(".SepetProducts").height() - 140;
    //        $(".BasketCenterContent").height(ContentHeight);
    //        $(".BasketCenterContent").css("max-height", ContentHeight);
    //    });
    //}

    $(".BasketContainer .RemoveIcon").live("click", function () {

        var Silid = $(this).attr("data-id").replace("sepetsil", "");
        var pid = $(this).attr("data-productid");
        var LangID = $("#LangID").val();
        var ColorID = $(this).attr("data-colorid");

        $("#DeleteAndAddFavorite").find("#deleteCart").attr("data-id", Silid);
        $("#DeleteAndAddFavorite").find("#addFavorite").attr("data-id", Silid);
        $("#DeleteAndAddFavorite").find("#addFavorite").attr("data-productid", pid);
        $("#DeleteAndAddFavorite").find("#deleteCart").attr("data-langid", LangID);
        $("#DeleteAndAddFavorite").find("#addFavorite").attr("data-langid", LangID);
        $("#DeleteAndAddFavorite").find("#addFavorite").attr("data-colorid", ColorID);

        $('#DeleteAndAddFavorite').modal("show");


    });

    $("#DeleteAndAddFavorite .deleteCart").live("click", function () {
        $('#DeleteAndAddFavorite').modal("hide");
        var Silid = 0;

        if ($(this).attr("data-id") != undefined && $(this).attr("data-id").length > 0) {

            Silid = $(this).attr("data-id").replace("sepetsil", "");
        }
        var ColorId = $(this).attr("data-colorid");
        var ProductId = $(this).attr("data-productid");
        var gizlenecekSecim = $(this).parent().parent();
        var nameOfCurItem = "";
        if ($(this).closest(".SepetRow").length > 0) {

            gizlenecekSecim = $(this).closest(".SepetRow");
            nameOfCurItem = $(gizlenecekSecim).find(".SepetPrdHeader").text();
        }
        var LangID = $("#LangID").val();

        $(gizlenecekSecim).find(".ustSepetAjaxLoader").show();
        $(gizlenecekSecim).find(".ustSepetDelete").hide();
        $(gizlenecekSecim).css("opacity", "0.5");

        dataall = "";

        if ($(this).attr("data-all") == "true") {

            dataall = "&all=true";
            gizlenecekSecim = $(".SepetProducts");
        }

        if (1 == 1 || $(".ProductDetail").length > 0) {
            dataall += "&pd=true";
        }


        $removedItem = $(gizlenecekSecim).clone();

        $.ajax({
            type: 'get',
            url: '/' + $("#SmallLangCode").val() + '/p/Cart/RemoveFromCart',
            data: 'id=' + Silid + "&langID=" + LangID + dataall,
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            success: function (dt) {
                if (dt.Sonuc == true) {

                    //#region Related Datalayer Add To Basket Operation
                    if (dt.Deger8 !== null && dt.Deger8 !== undefined && window.dataLayer !== null && window.dataLayer !== undefined) {
                        window.dataLayer.push(JSON.parse(dt.Deger8));
                    }
                    //#endregion

                    $.ajax({
                        type: 'get',
                        url: "/" + $("#SmallLangCode").val() + "/p/Cart/GetSepetIcerik",
                        data: "",
                        async: true,
                        contentType: "application/json; charset=utf-8",
                        dataType: 'text',
                        success: function (dt) {
                            $("#UserMenus  #UserAndBasket").html(dt);

                            AddSearchBox();

                            $('html, body').animate({ scrollTop: 0 }, 'slow');

                            $(".RightBasket").addClass("active");
                            $("body").addClass("BackDropped");

                            $(".SepetProducts").hide();
                            $(".SepetProducts").addClass("activeBasket");
                            setContentHeight();
                            //setBasketContainerHeight();
                            $(".AjaxLoader").hide();
                        }
                    });
                }
                else {
                    alert(dt.IslemSonucAciklama);
                }
            }
        });

    });

    $("#DeleteAndAddFavorite .addFavorite").live("click", function () {
        var Silid = 0;
        $('#DeleteAndAddFavorite').modal("hide");

        if ($(this).attr("data-id") != undefined && $(this).attr("data-id").length > 0) {

            Silid = $(this).attr("data-id").replace("sepetsil", "");
        }
        var ColorId = $(this).attr("data-colorid");
        var ProductId = $(this).attr("data-productid");
        var gizlenecekSecim = $(this).parent().parent();
        var nameOfCurItem = "";
        if ($(this).closest(".SepetRow").length > 0) {

            gizlenecekSecim = $(this).closest(".SepetRow");
            nameOfCurItem = $(gizlenecekSecim).find(".SepetPrdHeader").text();
        }
        var LangID = $("#LangID").val();

        $(gizlenecekSecim).find(".ustSepetAjaxLoader").show();
        $(gizlenecekSecim).find(".ustSepetDelete").hide();
        //$(gizlenecekSecim).css("opacity", "0.5");

        dataall = "";

        if ($(this).attr("data-all") == "true") {

            dataall = "&all=true";
            gizlenecekSecim = $(".SepetProducts");
        }

        if (1 == 1 || $(".ProductDetail").length > 0) {
            dataall += "&pd=true";
        }

        $removedItem = $(gizlenecekSecim).clone();

        $.ajax({
            type: 'get',
            url: '/' + $("#SmallLangCode").val() + '/p/Cart/RemoveFromCart',
            data: 'id=' + Silid + "&langID=" + LangID + dataall,
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            success: function (dt) {
                if (dt.Sonuc == true) {

                    //#region Related Datalayer Add To Basket Operation
                    if (dt.Deger8 !== null && dt.Deger8 !== undefined && window.dataLayer !== null && window.dataLayer !== undefined) {
                        window.dataLayer.push(JSON.parse(dt.Deger8));
                    }
                    //#endregion

                    $.ajax({
                        type: 'get',
                        url: "/" + $("#SmallLangCode").val() + "/p/Cart/GetSepetIcerik",
                        data: "",
                        async: true,
                        contentType: "application/json; charset=utf-8",
                        dataType: 'text',
                        success: function (dt) {
                            $("#UserMenus  #UserAndBasket").html(dt);

                            AddSearchBox();

                            $('html, body').animate({ scrollTop: 0 }, 'slow');

                            $(".RightBasket").addClass("active");
                            //$("body").addClass("BackDropped");

                            $(".SepetProducts").hide();
                            $(".SepetProducts").addClass("activeBasket");
                            setContentHeight();
                            //setBasketContainerHeight();
                            $(".AjaxLoader").hide();
                        }
                    });
                }
                else {
                    alert(dt.IslemSonucAciklama);
                }
            }
        });

        AddToFavoriteNewMain(ProductId, ColorId);



    });


    $(".BasketContainer .RemoveIcosn").live("click", function () {


        var Silid = 0;

        if ($(this).attr("data-id") != undefined && $(this).attr("data-id").length > 0) {

            Silid = $(this).attr("data-id").replace("sepetsil", "");
        }

        var gizlenecekSecim = $(this).parent().parent();
        var nameOfCurItem = "";
        if ($(this).closest(".SepetRow").length > 0) {

            gizlenecekSecim = $(this).closest(".SepetRow");
            nameOfCurItem = $(gizlenecekSecim).find(".SepetPrdHeader").text();
        }
        var LangID = $("#LangID").val();

        $(gizlenecekSecim).find(".ustSepetAjaxLoader").show();
        $(gizlenecekSecim).find(".ustSepetDelete").hide();
        $(gizlenecekSecim).css("opacity", "0.5");

        dataall = "";

        if ($(this).attr("data-all") == "true") {

            dataall = "&all=true";
            gizlenecekSecim = $(".SepetProducts");
        }

        if (1 == 1 || $(".ProductDetail").length > 0) {
            dataall += "&pd=true";
        }

        $removedItem = $(gizlenecekSecim).clone();

        $.ajax({
            type: 'get',
            url: '/' + $("#SmallLangCode").val() + '/p/Cart/RemoveFromCart',
            data: 'id=' + Silid + "&langID=" + LangID + dataall,
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            success: function (dt) {
                if (dt.Sonuc == true) {

                    //#region Related Datalayer Add To Basket Operation
                    if (dt.Deger8 !== null && dt.Deger8 !== undefined && window.dataLayer !== null && window.dataLayer !== undefined) {
                        window.dataLayer.push(JSON.parse(dt.Deger8));
                    }
                    //#endregion

                    $.ajax({
                        type: 'get',
                        url: "/" + $("#SmallLangCode").val() + "/p/Cart/GetSepetIcerik",
                        data: "",
                        async: true,
                        contentType: "application/json; charset=utf-8",
                        dataType: 'text',
                        success: function (dt) {
                            $("#UserMenus  #UserAndBasket").html(dt);

                            AddSearchBox();

                            $('html, body').animate({ scrollTop: 0 }, 'slow');

                            $(".RightBasket").addClass("active");
                            $("body").addClass("BackDropped");

                            $(".SepetProducts").hide();
                            $(".SepetProducts").addClass("activeBasket");
                            setContentHeight();
                            //setBasketContainerHeight();
                            $(".AjaxLoader").hide();
                        }
                    });
                }
                else {
                    alert(dt.IslemSonucAciklama);
                }
            }
        });
    });

    if (isMobile(true)) {
        $("#PayNow").live("mouseenter", function (e) {

            document.location.href = $(this).attr("href");

        });
    }

    $('.RightSearch').live('click', function (e) {
        console.info($("body").hasClass("Scrolled"))
        if ($("body").hasClass("Scrolled")) {

            $("body").addClass("Scrolled");
            $("body").addClass("BackDropped");

        }
        else {
            $("body").addClass("BackDropped");
        }


        $(".SearchModal").show();

        $(".SearchModal input:first").focus();
        $('html, body').animate({ scrollTop: 0 }, 'slow');


    });

    $('.headerSearchButton').live('click', function (e) {

        $("body").addClass("BackDropped");
        $(".SearchModal").show();

        $(".SearchModal input:first").focus();
        $('html, body').animate({ scrollTop: 0 }, 'slow');


    });

    $('.OpenLeftMenu, .CloseLeftMenu, .ToggleMMenuIcon , .MainIcon').live('click', function (e) {
        $("#Mainmenu ul li div.itemsWrapper").hide();
        $("#MainMenu").toggleClass("open");
        if ($("#MainMenu").hasClass("open") == true) {

            $("#MainMenu > ul > li:not(.TabletMenu):not(.SearchInMenu):not(.MobileUserMenu)").each(function () {
                //$(this).find("a:first").html("&nbsp;");

                var BackgroundBanner = $(this).attr("data-banner");

                if (BackgroundBanner != null && BackgroundBanner != "" && BackgroundBanner != undefined) {
                    $(this).css("background", "url(" + BackgroundBanner + ")");
                    $(this).find("a:first").css("background", "none");
                }
            });
            //$('html, body').animate({ scrollTop: 0 }, 'slow');
            $("body").addClass("BackDropped LeftMenuOpen");

        }
        else {

            $("body").removeClass("BackDropped LeftMenuOpen");

        }

    });

    $('.SearchModal form input').keyup(function (event) {

        if (event.keyCode == 27) {

            $("body").removeClass("BackDropped");
            $(".SearchModal").hide();

        }
    });

    $('.CloseSearch').click(function (event) {


        $("body").removeClass("BackDropped");
        $(".SearchModal").hide();

    });

    if ($("#FbConfirmMergeModal").length > 0) {
        $("#FbConfirmMergeModal").modal("show");
    }

    if ($("#FbMergeResultModal").length > 0) {
        $("#FbMergeResultModal").modal("show");
    }

    if (window.location.hash == "#Rg" && isMobile(true)) {
        $('html, body').animate({
            scrollTop: $("#LineRg").offset().top + -80
        }, 500);
    }

    if (window.location.hash != undefined && document.URL.indexOf("Yardim") > 0) {
        var curHash = window.location.hash.replace("#", "");

        $("#helpMenu a[href$='" + curHash + "']").trigger("click");
    }

    if (window.location.hash == "#Lg" && isMobile(true)) {
        $('html, body').animate({
            scrollTop: $(".GeneralBreadCrumb:first").offset().top + -50
        }, 500);
    }

    $(".ForgetPass").on("click", function (e) {

        $("#forgottenpassModal").modal('show');

    });

    $(".PopupRegisterBanner").on("click", function (e) {

        $(".RegisterInBanner").click();

    });

    $(".RegisterInBanner").on("click", function (e) {

        $(".LoginRegisterContainer").toggle();
        $(".LoginRegisterContainer").closest(".row-fluid, .row").toggle();
        $(".PopupRegisterBannerContainer").toggleClass("Bordered");

        $("li.tb").removeClass("active");

        if (isMobile(true)) {

            $(this).closest("div.RwRegisterLogin").find("div.UyeKayitCol").removeClass("pull-right");

            if ($(".UyeOlModal:visible").length > 0) {

                $("li.tb.reg").addClass("active");

            }
            else {

                $("li.tb.log").addClass("active");

            }

        } else {

            if ($(this).closest("div.RwRegisterLogin").find("div.UyeKayitCol").hasClass("pull-right")) {

                $(this).text($(this).attr("data-cur"));
                $(this).closest("div.RwRegisterLogin").find("div.UyeKayitCol").removeClass("pull-right");

                $("li.tb.reg").addClass("active");


            }
            else {

                $(this).text($(this).attr("data-other"));
                $(this).closest("div.RwRegisterLogin").find("div.UyeKayitCol").addClass("pull-right");

                $("li.tb.log").addClass("active");

            }

        }

        $cur = $(".LoginRegisterContainer");

        $cur.css("opacity", "0.1");

        $cur.animate({
            opacity: 1
        }, 500, function () {
        });


    });

    $(".LogRegTabs li").on("click", function (e) {

        $(".RegisterInBanner").click();

    });

    $("#PayNow").on("click", function (e) {

        document.location.href = $(this).attr("href");

    });
    $(".ModalTab").on("click", function (e) {

        $(".ModalTab").removeClass("active");
        $(this).addClass("active");

        if ($(this).hasClass("Login")) {
            $(".LoginRow").show();
            $(".RegisterRow").hide();
        }
        else {

            $(".LoginRow").hide();
            $(".RegisterRow").show();
        }


    });

    //$("#AccountMenu a.LoginIcon, #AccountMenu a.RegisterIcon").live("click", function (e) {
    //    if ($("#LoginRegisterModal").length > 0) {
    //        $("#LoginRegisterModal").modal("show");

    //        if ($(this).hasClass("RegisterIcon") == true) {
    //            $(".ModalTab.Register").trigger("click");
    //        }
    //        else {
    //            $(".ModalTab.Login").trigger("click");
    //        }

    //        e.preventDefault();
    //        return false;
    //    }
    //});

    if ($("#WelcomeModal").length > 0) {
        $('#WelcomeModal').modal({
            // backdrop: "static"
        });
    }

    $("form.UyeOlModal").live("submit", function () {

        $form = $(this);

        $("#LoginButton").attr("disabled", "disabled");
        $(".AjaxLoader").show();

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            success: function (dt) {

                $(".AjaxLoader").hide();
                $("#LoginButton").removeAttr("disabled");

                if (dt.Sonuc == true) {

                    /*
                    if (UseTagManager) {
                        AddUserAction("SignUp");
                    }

                    if (dt.JsonRs == "Redirect") {
                        if (dt.Deger5.length > 0) {
                            document.location = dt.Deger5;
                        }
                        else {
                            document.location = "/";
                        }
                    }
                    else if (dt.JsonRs == "Redirect") {

                        $form.hide();
                        $(".AjaxLoader").show();
                        $(".RwRegisterLogin").hide();

                        document.location = "/";
                    }

                    if (dt.JsonRs == "Reload") {
                        $form.hide();
                        $(".AjaxLoader").show();
                        $(".RwRegisterLogin").hide();
                        document.location.reload();
                    }
                    */

                    $("#AlertResult").removeClass("alert-error");
                    $("#AlertResult").addClass("alert-success").show().find("span").html(dt.IslemSonucAciklama);
                    $form.hide();
                    $("#AlertResult").parent().append("<a class='GenericLoginButton' id='start-shopping-button' href='/'>ALIŞVERİŞE BAŞLA</a>");


                    //$("#AlertResult").hide();

                    //if ($("#register_FbRedirectUrl").length > 0 && $("#register_FbRedirectUrl").val() != "" && $("#register_FbRedirectUrl").val().indexOf("undefined") != -1) {
                    //    document.location = $("#register_FbRedirectUrl").val();
                    //}
                }
                else {
                    $("#AlertResult").removeClass("alert-success");
                    $("#AlertResult").addClass("alert-danger");
                    $("#AlertResult").addClass("alert-error").show().find("span").html(dt.IslemSonucAciklama);
                }
            },
            error: function () {
                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }
        });

        return false;
    });

    $("form.UyeGirisModal").live("submit", function () {

        $form = $(this);

        $("#LoginButton").attr("disabled", "disabled");
        $(".AjaxLoader").show();

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            success: function (dt) {

                $(".AjaxLoader").hide();
                $("#LoginButton").removeAttr("disabled");

                if (dt.Sonuc == true) {

                    if (UseTagManager) {
                        AddUserAction("Login");
                    }

                    if (dt.JsonRs == "Reload") {

                        $("#AlertResult").removeClass("alert-danger");
                        $("#AlertResult").addClass("alert-success").show().find("span").html(dt.IslemSonucAciklama);

                        $(".AjaxLoader").show();
                        $form.hide();
                        $(".RwRegisterLogin").hide();

                        document.location.reload();

                    }


                    if (dt.JsonRs == "Redirect") {

                        $form.hide();
                        $(".AjaxLoader").show();
                        $(".RwRegisterLogin").hide();

                        document.location = dt.Deger5;
                    }

                    $("#AlertResult").removeClass("alert-danger");

                    if ($("#register_FbRedirectUrl").length > 0 && $("#register_FbRedirectUrl").val() != "" && $("#register_FbRedirectUrl").val().indexOf("undefined") != -1) {
                        document.location = $("#register_FbRedirectUrl").val();
                    }


                }
                else {

                    $("#AlertResult").removeClass("alert-success");
                    $("#AlertResult").addClass("alert-danger").show().find("span").html(dt.IslemSonucAciklama);
                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


        return false;


    });

    // PRODUCTS HOVER 
    $(".ProductList .Prd a").live('click', function (e) {

        if (UseTagManager == true) {

            AddGaEvent('', 'Product List', 'Product Click', $(this).closest(".Prd"));

        }

        //return false;
        //e.preventDefault();


    });

    //if (isMobile(false) && isAppleMobile() && !IsAndroid()) {
    //    $(".ProductList .Prd").live('click', function (e) {
    //        document.location.href = $(this).find("a:first").attr("href");
    //    });
    //}

    var ScrollContentID = "LastScrollTop" + $("#PID").val();

    //if (isMobile(true) == false) {

    //    $(".ProductList .Prd").live({
    //        mouseenter:
    //        function () {
    //            $.cookie(ScrollContentID, null, { expires: -1 });
    //            $.cookie(ScrollContentID, $(window).scrollTop(), { expires: 0.05 });

    //            if (isMobile(false) && isAppleMobile() && !IsAndroid()) {
    //                document.location.href = $(this).find("a:first").attr("href");
    //            }

    //            $nextPrd = $(this).next();
    //            $prevPrd = $(this).prev();
    //            $curItem = $(this);
    //            $row = $curItem.parent();

    //            var index = $curItem.index();

    //            $topPrd = $(this).closest(".row").prev().find(".Prd:eq(" + index + ")");
    //            $bottomPrd = $(this).closest(".row").next().find(".Prd:eq(" + index + ")");

    //            if ($(this).find(".img2").length > 0 && $(this).find(".img2").attr("src") != undefined && $(this).find(".img2").attr("src") != "/images/src2.gif" && $(this).find(".img2").attr("src") != "") {

    //                $(this).find(".img1").hide();

    //                if ($(this).find(".img2").attr("data-src") != undefined && ($(this).find(".img2").attr("src") == undefined || $(this).find(".img2").attr("src").indexOf("404") != -1)) {
    //                    $(this).find(".img2").attr("src", $(this).find(".img2").attr("data-src"));
    //                }

    //                $(this).find(".img2").show();

    //            }

    //            if ($nextPrd.length > 0) {

    //                if ($nextPrd.find(".img2").length > 0 && $(this).find(".img2").attr("src") != undefined && $nextPrd.find(".img2").attr("src") != "/images/src2.gif" && $nextPrd.find(".img2").attr("src") != "") {

    //                    if ($nextPrd.find(".img2").attr("data-src") != undefined && ($nextPrd.find(".img2").attr("src") == undefined || $nextPrd.find(".img2").attr("src").indexOf("404") != -1)) {
    //                        $nextPrd.find(".img2").attr("src", $nextPrd.find(".img2").attr("data-src"));
    //                    }


    //                }
    //            }

    //            if ($prevPrd.length > 0) {

    //                if ($prevPrd.find(".img2").length > 0 && $prevPrd.find(".img2").attr("src") != "/images/src2.gif" && $prevPrd.find(".img2").attr("src") != "") {

    //                    if ($prevPrd.find(".img2").attr("data-src") != undefined && ($prevPrd.find(".img2").attr("src") == undefined || $prevPrd.find(".img2").attr("src").indexOf("404") != -1)) {
    //                        $prevPrd.find(".img2").attr("src", $prevPrd.find(".img2").attr("data-src"));
    //                    }

    //                }

    //            }

    //            if ($topPrd.length > 0) {

    //                if ($topPrd.find(".img2").length > 0 && $topPrd.find(".img2").attr("src") != "/images/src2.gif" && $topPrd.find(".img2").attr("src") != "") {

    //                    if ($topPrd.find(".img2").attr("data-src") != undefined && ($topPrd.find(".img2").attr("src") == undefined || $topPrd.find(".img2").attr("src").indexOf("404") != -1)) {
    //                        $topPrd.find(".img2").attr("src", $topPrd.find(".img2").attr("data-src"));
    //                    }


    //                }
    //            }

    //            if ($bottomPrd.length > 0) {

    //                if ($bottomPrd.find(".img2").length > 0 && $bottomPrd.find(".img2").attr("src") != "/images/src2.gif" && $bottomPrd.find(".img2").attr("src") != "") {

    //                    if ($bottomPrd.find(".img2").attr("data-src") != undefined && ($bottomPrd.find(".img2").attr("src") == undefined || $bottomPrd.find(".img2").attr("src").indexOf("404") != -1)) {
    //                        $bottomPrd.find(".img2").attr("src", $bottomPrd.find(".img2").attr("data-src"));
    //                    }

    //                }

    //            }

    //        },
    //        mouseleave:
    //        function () {

    //            if ($(this).find(".img2").length > 0 && $(this).find(".img2").attr("src") != "/images/src2.gif" && $(this).find(".img2").attr("src") != "") {

    //                $(this).find(".img2").hide();
    //                $(this).find(".img1").show();
    //            }

    //        }
    //    });
    //}

    $('.ProductList .Prd').live("click", function (e) {

        $.cookie(ScrollContentID, null, { expires: -1 });
        $.cookie(ScrollContentID, $(window).scrollTop(), { expires: 0.05 });

    });

    $('.ProductListColorContainer div.ProductListColor:not(.passive)').live("click", function () {

        var $currentColor = $(this);

        $(".AjaxLoader").show();

        var productID = $(this).attr("data-color-product-id");
        var colorID = $(this).attr("data-color");
        var item_unique_id = $(this).attr("data-item-unique-id");
        var params = "language=" + $("#SmallLangCode").val() + "&ColorID=" + colorID + "&ProductID=" + productID;

        $detailLinks = $(this).closest(".Prd").find("a");

        $currentColor.closest(".ProductListColorContainer").find(".ProductListColor").removeClass("active");

        $currentColor.addClass("active");

        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetImageOfColors",
            data: params,
            success: function (data) {

                $(".AjaxLoader").hide();

                $Crs = $("#Crs_" + item_unique_id);

                $Crs.find("div.carousel-inner").html("");
                var urlNew = "/";
                //kategori sayfasında ürün resime tıklandığında gidecek urli ayarlama.
                if (data.ProductUrl != undefined && data.ColorUrl != undefined) {
                    //urlNew += $("#SmallLangCode").val() + "/" + data.ColorName + "-" + data.ProductUrl + data.ColorUrl;
                    urlNew += $("#SmallLangCode").val() + "/" + data.ProductUrl;
                }
                var sizeQuery = "_614x805";

                if (data.ImgPath1 != null) {
                    var $imgKucuk1 = $('<div class="active item"><a href="' + urlNew + '" ><img class="img1 PImage img-responsive" alt="" src="' + data.ImgPath1.replace("_buyuk", sizeQuery) + '" ></a></div>');
                    $imgKucuk1.appendTo($Crs.find("div.carousel-inner"));
                }
                if (data.ImgPath2 != null) {
                    var $imgKucuk2 = $('<div class="item"><a href="' + urlNew + '" ><img class="img2 PImage img-responsive" alt="" src="' + data.ImgPath2.replace("_buyuk", sizeQuery) + '" ></a></div>');
                    $imgKucuk2.appendTo($Crs.find("div.carousel-inner"));
                }
                if (data.ImgPath3 != null) {
                    var $imgKucuk3 = $('<div class="item"><a href="' + urlNew + '" ><img class="img3 PImage img-responsive" alt="" src="' + data.ImgPath3.replace("_buyuk", sizeQuery) + '" ></a></div>');
                    $imgKucuk3.appendTo($Crs.find("div.carousel-inner"));
                }
                if (data.ImgPath4 != null) {
                    var $imgKucuk4 = $('<div class="item"><a href="' + urlNew + '" ><img class="img4 PImage img-responsive" alt="" src="' + data.ImgPath4.replace("_buyuk", sizeQuery) + '" ></a></div>');
                    $imgKucuk4.appendTo($Crs.find("div.carousel-inner"));
                }

                //AddToCart attributeleri değiştir
                $currentColor.closest(".Prd").find(".AddToCart").attr("data-colorid", data.ColorID);
                $currentColor.closest(".Prd").find(".AddToCart").attr("data-productid", data.ProductID);
                $currentColor.closest(".Prd").find(".AddToCart").attr("data-sizeid", data.SizeID);

                $currentColor.closest(".Prd").find(".ProductBadge").html("");

                //sistemde tanımlı badgeler varsa eklenmeli.
                if (data.BadgeImagePath != null && data.BadgeImagePath != undefined && data.BadgeTur != 14) {

                    if (data.BadgeTur == 7) {

                        $currentColor.closest(".Prd").find(".ProductBadge").html('<div class="badge badge-right-top-padding"><img src="' + data.BadgeImagePath + '" /></div>');

                    } else if (data.BadgeTur == 8) {

                        $currentColor.closest(".Prd").find(".ProductBadge").html('<div class="badge badge-left-top-padding"><img src="' + data.BadgeImagePath + '" /></div>');


                    } else if (data.BadgeTur == 9) {

                        $currentColor.closest(".Prd").find(".ProductBadge").html('<div class="badge badge-right-bottom-padding"><img src="' + data.BadgeImagePath + '" /></div>');


                    } else if (data.BadgeTur == 10) {

                        $currentColor.closest(".Prd").find(".ProductBadge").html('<div class="badge badge-left-bottom-padding"><img src="' + data.BadgeImagePath + '" /></div>');

                    }
                }

                //alert("Amount:" + data.Amount);
                //alert("Amount:" + data.AmountOld);

                if (data.Amount !== null && data.Amount !== undefined && data.Amount !== "" && typeof (data.Amount) !== undefined) {
                    $currentColor.closest(".Prd").find(".PriceArea").find(".PPrice").text(data.CurrencySymbol + data.Amount);

                }

                if (data.AmountOld !== null && data.AmountOld !== undefined && data.AmountOld !== "" && typeof (data.AmountOld) !== undefined) {
                    $currentColor.closest(".Prd").find(".PriceArea").find(".PPOldPrice").text(data.CurrencySymbol + data.AmountOld);
                }

                //if (data.Amount < data.AmountOld) {
                //    if ($("#SmallLangCode").val() === "tr") {
                //        $currentColor.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-right-top-padding freeShipping'><img src='/images/JMK/badge/kargo.png'></div>");
                //    }
                //}

                if (data.DiscountRate !== null && data.DiscountRate !== undefined && data.DiscountRate !== "" && typeof (data.DiscountRate) !== undefined) {
                    if ($("#SmallLangCode").val() === "tr") {
                        $currentColor.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-left-top-padding'><span class='discount'>" + data.DiscountRate + "%</span><img src='/images/JMK/badge/indirim_bagde.png'></div>");
                    }
                }


                if (data.TotalQuantity <= 0) {
                    $currentColor.closest(".Prd").find(".AddToCart").addClass("passive");
                    $currentColor.closest(".Prd").find(".AddToCart").attr('disabled', 'disabled');

                }
                else {
                    $currentColor.closest(".Prd").find(".AddToCart").removeClass("passive").removeAttr("disabled");
                }

                if (typeof UseSwStat != 'undefined' && UseSwStat == true) {

                    var swparams = GetSwPageParams();

                    swparams = ChangeSwHashedStringParamValue(swparams, "ActionType", "UrunRenkDegistirme");

                    swparams = ChangeSwHashedStringParamValue(swparams, "ProductID", productID);
                    swparams = ChangeSwHashedStringParamValue(swparams, "ColorID", colorID);

                    AddSwAction(swparams);

                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });

        //size divini yenilesin

        $currentColor.closest("div.AddToCartArea").find("div.ProductListSizeContainer.plSize").remove();




    });

    $('.ProductListSizeContainer div.ProductListSize:not(.passive)').live("click", function () {

        var $currentColor = $(this);

        $(".AjaxLoader").show();

        var productID = $(this).attr("data-color-product-id");
        var colorID = $(this).attr("data-color");
        var sizeID = $(this).attr("data-size");

        $currentColor.closest(".Prd").find(".AddToCart").attr("data-sizeid", sizeID);
        $currentColor.closest(".ProductListSizeContainer").find(".ProductListSize").removeClass("active");

        $currentColor.addClass("active");

        $currentColor.closest(".Prd").find(".AddToCart").click(); //sepet eklesin hemen
        $(".AjaxLoader").hide();
    });

    AddToCartAreaWidthSet();

    //SEPETE EKLE
    //$(".ProductList .Prd .AddToCartArea button.AddToCart").click(function (e) {
    $(document).on('click', '.ProductList .Prd .AddToCartArea button.AddToCart', function (e) {

        $basketButton = $(this);

        var SizeID = $basketButton.attr("data-sizeid");
        var ColorID = $basketButton.attr("data-colorid");
        var ProductID = $basketButton.attr("data-productid");
        var LangID = $("#SmallLangCode").val();
        var Amount = "1";



        if (SizeID != undefined && ColorID != undefined && ProductID != undefined && SizeID != "" && ColorID != "" && ProductID != "" && SizeID != "0" && ColorID != "0" && ProductID != "0") {

            var NormalText = $basketButton.text();
            var AddingText = $basketButton.attr("data-adding");
            $basketButton.text(AddingText);

            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddToCart",
                data: 'sizeID=' + SizeID + "&colorID=" + ColorID + "&productID=" + ProductID + "&adet=" + Amount + "&langID=" + LangID,
                dataType: 'json',
                async: true,
                success: function (dt) {

                    if ($(window).width() < 768) {
                        $basketButton.html("<div class='BasketIcon hidden-md hidden-lg'></div>" + NormalText);
                    }
                    else {
                        $basketButton.text(NormalText);
                    }

                    $("#GeneralModal .modal-header h3").html(dt.IslemSonucAciklama);

                    if (dt.Sonuc == true) {
                        $Modal = $("div#QuickLookModal");

                        if ($Modal.length > 0) {
                            $Modal.modal("hide");
                        }

                        //#region Related Datalayer Add To Basket Operation
                        if (dt.Deger8 !== null && dt.Deger8 !== undefined && window.dataLayer !== null && window.dataLayer !== undefined) {
                            window.dataLayer.push(JSON.parse(dt.Deger8));
                        }
                        //#endregion

                        $.ajax({
                            type: 'get',
                            url: "/" + $("#SmallLangCode").val() + "/p/Cart/GetSepetIcerik",
                            data: "",
                            async: true,
                            contentType: "application/json; charset=utf-8",
                            dataType: 'text',
                            success: function (dt) {

                                $("#UserMenus  #UserAndBasket").html(dt);

                                AddSearchBox();

                                //$('html, body').animate({ scrollTop: 0 }, 'slow');

                                $(".RightBasket").addClass("active");
                                $("body").addClass("BackDropped");

                                $(".SepetProducts").hide();
                                $(".SepetProducts").addClass("activeBasket");
                                //setBasketContainerHeight();
                                setContentHeight();
                                $(".AjaxLoader").hide();

                                $basketButton.closest("div.AddToCartArea").find("button.AddToCart").attr("data-sizeid", "0");
                                $basketButton.closest("div.AddToCartArea").find("div.ProductListSizeContainer.plSize").remove();
                            }
                        });

                        if (typeof UseSwStat != 'undefined' && UseSwStat == true) {

                            var basketParams = GetSwPageParams();

                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ActionType", "SepeteEkleme");
                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ProductID", ProductID);
                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ColorID", ColorID);
                            basketParams += "&CatalogID=" + $("#CurCatalogID").val();

                            AddSwAction(basketParams);
                        }

                        if (UseTagManager) {
                            SendCartAddEvent('');
                        }
                    }
                    else {
                        alert(dt.IslemSonucAciklama);
                    }
                }
            });
        }
        else if (SizeID === "0" && $basketButton.closest("div.AddToCartArea").find("div.ProductListSizeContainer.plSize").length === 0) {

            var params = "ColorID=" + ColorID + "&ProductID=" + ProductID;

            $.ajax({
                type: "GET",
                url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetSizeOfColors",
                data: params,
                success: function (data) {

                    $(".AjaxLoader").hide();

                    $basketButton.closest("div.AddToCartArea").find("button.AddToCart").before(data);

                    var $firstSize = $basketButton.closest("div.AddToCartArea").find("div.ProductListSizeContainer.plSize").find(".ProductListSize.active:first");

                    var firstSizeId = ($firstSize.length > 0 ? $firstSize.attr("data-size") : 0);

                    $basketButton.removeClass("passive");

                    if (firstSizeId === 0) {
                        $basketButton.addClass("passive");

                        //if ($("#SmallLangCode").val() === "tr") {
                        //    $basketButton.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-left-top-padding'><img src='/images/JMK/badge/tukendi.png'></div>");

                        //}
                        //else if ($("#SmallLangCode").val() === "en") {
                        //    $basketButton.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-left-top-padding'><img src='/images/JMK/badge/sold_out.png'></div>");
                        //}
                        //else if ($("#SmallLangCode").val() === "fr") {
                        //    $basketButton.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-left-top-padding'><img src='/images/JMK/badge/epuise.png'></div>");
                        //}
                    }

                    //***** ilk size id default seçili gelmesin dediler. o yüzden AddToCarta sizeid yazmasın ve size kutularındaki active kaldırılıyor. 
                    //size kutularına ilk başta active classı eklememizin sebebi yukarıda tukendi badge çıkartabilmek için
                    //$basketButton.attr("data-sizeid", firstSizeId);
                    $basketButton.closest("div.AddToCartArea").find("div.ProductListSizeContainer.plSize").find(".ProductListSize").removeClass("active");
                },
                error: function () {

                    alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
                }

            });
        }

        e.preventDefault();
        return false;

    });

    if ($(".ContentPgArea").length > 0 && isMobile(true)) {
        $('html, body').animate({ scrollTop: $(".ContentPgArea").offset().top }, 'slow');
    }

    $("form.ForgettenForm").live("submit", function () {

        $form = $("form.ForgettenForm");

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: 'json',
            success: function (dta) {

                if (dta.Sonuc == true) {

                    $(".ForgettenForm p:first").html(dta.IslemSonucAciklama);

                    $("#email").hide();
                    $("#forgottenPassSubmit").hide();

                    $(".ForgettenForm p:first").removeClass("alert-error");
                    $(".ForgettenForm p:first").addClass("alert alert-success");

                }
                else {

                    $(".ForgettenForm p:first").html(dta.IslemSonucAciklama);
                    $(".ForgettenForm p:first").addClass("alert alert-error");
                }



            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


        return false;


    });

    $("form.UyeOl").live("submit", function () {

        $form = $(this);

        $("#LoginButton").attr("disabled", "disabled");
        $(".AjaxLoader").show();
        $(".Header1, .Header2").hide();

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            success: function (dt) {

                $(".AjaxLoader").hide();
                $("#LoginButton").removeAttr("disabled");


                if (dt.Sonuc == true) {

                    if (dt.JsonRs == "Redirect") {
                        if (dt.Deger5.length > 0) {
                            document.location = dt.Deger5;
                        }
                        else {
                            document.location = "/";
                        }
                    }

                    $("#AlertResult").removeClass("alert-error");
                    $("#AlertResult").hide();

                    //$("#AlertResult").addClass("alert-success").show().find("span").html(dt.IslemSonucAciklama);

                    $form.hide();

                    if ($("#register_FbRedirectUrl").length > 0 && $("#register_FbRedirectUrl").val() != "" && $("#register_FbRedirectUrl").val().indexOf("undefined") != -1) {
                        document.location = $("#register_FbRedirectUrl").val();
                    }
                }
                else {

                    $("#AlertResult").removeClass("alert-success");
                    $("#AlertResult").addClass("alert-danger");
                    $("#AlertResult").addClass("alert-error").show().find("span").html(dt.IslemSonucAciklama);
                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


        return false;


    });

    //$(".FormButtons .SaveBtn").live("click", function () {

    //    $(this).attr("disabled", true);
    //    $.ajax({
    //        type: $("form.UserInfoForm").attr("method"),
    //        url: $("form.UserInfoForm").attr("action"),
    //        data: $("form.UserInfoForm").serialize(),
    //        cache: false,
    //        success: function (data) {
    //            $(".FormButtons .SaveBtn").attr("disabled", false);
    //            if (data.Sonuc == true) {
    //                $("#AlertResult").removeClass("alert-error");
    //                $("#AlertResult").addClass("alert-success").show().find("span").html(data.IslemSonucAciklama);
    //            }
    //            else {
    //                $("#AlertResult").removeClass("alert-success");
    //                $("#AlertResult").addClass("alert-error").show().find("span").html(data.IslemSonucAciklama);
    //            }
    //        },
    //        error: function () {
    //            $(".FormButtons .SaveBtn").attr("disabled", false);
    //            alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
    //        }
    //    });

    //});

    var utm_source = getQuery(window.location.href).utm_source;
    var utm_campaign = getQuery(window.location.href).utm_campaign;
    var utm_medium = getQuery(window.location.href).utm_medium;

    if ((utm_source != undefined && utm_source.length > 0) || (utm_campaign != undefined && utm_campaign.length > 0) || (utm_medium != undefined && utm_medium.length > 0)) {
        $.ajax({
            url: "/" + $("#SmallLangCode").val() + "/p/User/SetUtmParam",
            data: "utm_source=" + utm_source + "&utm_campaign=" + utm_campaign + "&utm_medium=" + utm_medium,
            type: "POST",
            cache: false
        });
    }

    $("#SwitchNewLayout").live("click", function () {

        changeSiteTheme($(this).attr("data-ly"));

    });

    if ($(window).width() < 993) {

        $("header .SepetRow").hammer().on("swiperight", function (e) {

            $(this).find(".RemoveIcon").trigger("click");

            e.stopPropagation();
            e.preventDefault();
        });

        $("header .SepetRow").hammer().on("swipeleft", function (e) {

            $(this).find(".RemoveIcon").trigger("click");

            e.stopPropagation();
            e.preventDefault();
        });

    }

    $("#SingOut").live("click", function (e) {

        if (UseTagManager) {
            AddUserAction("Signout");
        }
        //e.preventDefault();
        //return false;

    });

    if (1 == 2 && $("#homebannerFull1").length > 0 && !isMobile(true)) {

        $(document).snowfall('clear');
        $(document).snowfall({ shadow: true, round: true, minSize: 1, maxSize: 5, flakeCount: 200 }); // add shadows

    }


    if ($(window).width() > 1000) {


        $("#LoginRegisterModal .Login").live("click", function (e) {
            $('#LoginRegisterModal .modal-content').css();
        });

        $("#LoginRegisterModal .Register").live("click", function (e) {
            $('#LoginRegisterModal .modal-content').css();
        });

    }

    window.onpageshow = function (event) {
        if (event.persisted) {
            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/GetSepetIcerik",
                data: "",
                async: true,
                cache: false,
                contentType: "application/json; charset=utf-8",
                dataType: 'text',
                success: function (dt) {
                    $("#UserAndBasket").html(dt);

                    AddSearchBox();
                    TagAutoComplate();

                    if ($("#LangRedirectNeed").length > 0) {
                        //  changeSiteLanguage("0", $("#LangRedirectNeed").val());
                    }

                    if ($("#LangSelectionNeed").length > 0) {
                        ShowLangAreaForChange();
                    }

                    var UserID = $("#UserID").val();

                    if (UserID != undefined && UserID > 0) {
                        Isfollow();
                    }

                    if (UseTagManager) {
                        AddGeneralInfoTagManager('', dtIsLogged, dtUserID);

                        AddProductView('');
                        var promotions = GetPromotionsVariable('');
                        AddImpression('', promotions);
                        //  AddGASliderView('');

                        SendGaDataLayerVirtual();
                    }
                }
            });
        }
    };

    $("#register_Gsm").mask("999 999 99 99", {
        translation: {
            'Z': {
                pattern: /[0-9]/, optional: true
            }
        }
    });
    if ($("#register_Gsm").length > 0) {
        $(document).on("keyup", "#register_Gsm", function () {
            var phone = $(this).val();
            var firstChar = phone.substr(0, 1);

            if (firstChar != "5" && phone.length > 1) {
                $(this).val("");
            }
            else if (firstChar != "5") {
                phone = phone.substr(1, phone.length);
                $(this).val(phone);
            }
        });
    }

});

$(window).load(function () {
    $(".UseLazyLoad").Lazy();

    $("#NewOpenSearch a").live("click", function () {

        var search = $("#search").val();

        window.location.href = "/" + $("#SmallLangCode").val() + "/p/Cat/NewSearch?sr=" + search;

    });
});